import { render, staticRenderFns } from "./ChangeOverTimeLoading.vue?vue&type=template&id=51c4d48f&"
import script from "./ChangeOverTimeLoading.vue?vue&type=script&lang=js&"
export * from "./ChangeOverTimeLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51c4d48f')) {
      api.createRecord('51c4d48f', component.options)
    } else {
      api.reload('51c4d48f', component.options)
    }
    module.hot.accept("./ChangeOverTimeLoading.vue?vue&type=template&id=51c4d48f&", function () {
      api.rerender('51c4d48f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/change-over-time/ChangeOverTimeLoading.vue"
export default component.exports